import React from "react";
// @ts-ignore - React 18 types not yet installed, but runtime works correctly
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "@amzn/awsui-global-styles/polaris.css";
import App from "./App";
import { loadAppConfig } from "./config/config";
import Auth from "@aws-amplify/auth";
import store from "./redux/store";

// Enable Polaris visual refresh for modern AWS UI design
document.body.classList.add("awsui-visual-refresh");
document.body.classList.add("awsui-polaris-light-mode");

// Load configuration and initialize app
loadAppConfig()
  .then(({ config }) => {
    console.log("[Init] Configuration loaded, initializing Amplify...");

    // Configure Amplify with loaded config
    Auth.configure((config as any).AMPLIFY_CONFIG);

    const root = ReactDOM.createRoot(
      document.getElementById("root") as HTMLElement,
    );

    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <App />
        </Provider>
      </React.StrictMode>,
    );
  })
  .catch((error) => {
    console.error("[Init] Failed to load configuration:", error);
    // Still render app with default config
    const root = ReactDOM.createRoot(
      document.getElementById("root") as HTMLElement,
    );

    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <App />
        </Provider>
      </React.StrictMode>,
    );
  });
